import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";
import { ServiceTemplateDetails } from "@idw-types/data/service-template-details/service-template-details";
import { SERVICE_TEMPLATE_ID_PATTERN } from "@constants/url-parameter-patterns";

export const getServiceTemplateDetailsRequest = async (
    serviceTemplateId: string
): Promise<{ data: ServiceTemplateDetails, error: any }> => {
    const route = injectCustomIdParameter(apiRoutes.serviceConfiguration.data.serviceTemplateWithId, serviceTemplateId, SERVICE_TEMPLATE_ID_PATTERN);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};